import { useRef } from 'react';
import type { RefObject } from 'react';
import { useOnClickOutside, useOnEscPress } from '../../../hooks';

/**
 * Hook which manages the closing of a dialog when clicking outside of it or
 * pressing the ESC key, which is a common pattern in UIs.
 */
function useDialogHide<E extends HTMLElement = HTMLDivElement>(onHide: () => void): RefObject<E> {
  const ref = useRef<E>(null);
  //  Manage closing the panel when clicking outside of it or pressing ESC
  useOnClickOutside({ ref, handler: onHide });
  useOnEscPress(onHide);

  return ref;
}

export default useDialogHide;
